export const experienceData = [
    {
        id: 1,
        company: 'LastCloud',
        jobtitle: 'Web Developer',
        startYear: '01/02/2023',
        endYear: 'Present'
    },
   
    {
        id: 2,
        company: 'It-Plus',
        jobtitle: 'Full-Stack Developer',
        startYear: '01/12/2021',
        endYear: '30/08/2022'
    },
    
    {
        id: 3,
        company: 'Stem Lab SAL Team',
        jobtitle: 'Laravel Backend Developer',
        startYear: '01/08/2020',
        endYear: '30/10/2021'
    },
    

]